import React, { useContext } from "react";
import { Skeleton, Table } from "antd";
import FlowstationPerformanceStore from "../store/FlowstationPerformanceStore";

import { createContext } from "react";
import { Observer, observer } from "mobx-react-lite";
import { commaFormating } from "../../../../Utility/modules/helpers";
const flowstationPerformanceStoreCtx = createContext(
  FlowstationPerformanceStore
);
export const FlowstationProductionCard = () => {
  const flowstationPerformanceStore = useContext(
    flowstationPerformanceStoreCtx
  );
  const applyFormatting = (text, record, index) => {
    const params = { value: Math.round(text, 0) };
    return commaFormating(params);
  };
  const columns = [
    {
      title: "Flowstation",
      dataIndex: "flowstation",

      align: "left",
      key: "flowstation",
    },
    {
      title: (
        <b>
          Oil
          <br />
          (bopd)
        </b>
      ),
      dataIndex: "oil_Volume",

      align: "center",
      render: applyFormatting,
    },
    {
      title: (
        <b>
          Gas
          <br />
          (mscfd)
        </b>
      ),
      dataIndex: "gas_Volume",

      align: "center",
      render: applyFormatting,
    },
    {
      title: (
        <b>
          Gas
          <br />
          (boepd)
        </b>
      ),
      dataIndex: "gasBoe",

      align: "center",
      render: applyFormatting,
    },
    {
      title: <b>(BOEPD)</b>,
      dataIndex: "boe",

      align: "center",
      render: applyFormatting,
    },
  ];
  const alternateRows = (record, index) =>
    index % 2 ? "table-row" : " table-row table-row-alternate";

  return (
    <Observer>
      {() =>
        flowstationPerformanceStore.isLoading ? (
          <>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </>
        ) : (
          <Table
            title={() => (
              <h5
                className="ant-typography"
                style={{
                  display: "inline-block",

                  color: "red",
                }}
              >
                NAOC Flowstations Production{" "}
              </h5>
            )}
            dataSource={[
              ...flowstationPerformanceStore.flowstationProductions.values(),
            ]}
            columns={columns}
            pagination={false}
            size="small"
            rowKey="flowstation"
            rowClassName={alternateRows}
          />
        )
      }
    </Observer>
  );
};

